// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"b43a455c","396":"15c9cf52","453":"ad6d9bed","833":"0c232939","977":"62fd84ba"}[chunkId] + ".chunk.js";
};